import { LegalPage, LegalH, LegalP } from "../components/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" subtitle="Informativa ai sensi del Regolamento (UE) 2016/679 (GDPR) — Ultimo aggiornamento: gennaio 2026">
      <LegalH>1. Titolare del trattamento</LegalH>
      <LegalP>
        Il Titolare del trattamento dei dati è MP Coaching,
        con sede in Via Fratelli Garrone 79, Torino, P.IVA 13527260015,
        contattabile all'indirizzo email mpcoaching.online@gmail.com o al telefono 393 311 1439.
      </LegalP>
      <LegalH>2. Dati raccolti</LegalH>
      <LegalP>
        Raccogliamo i dati che ci fornisci volontariamente tramite il modulo contatti (nome, email, messaggio) e i dati
        necessari all'acquisto dei pacchetti di coaching (nome, email, dati di fatturazione). I dati di pagamento
        (numero di carta) sono trattati esclusivamente da Stripe e non transitano né vengono memorizzati sui nostri server.
      </LegalP>
      <LegalH>3. Finalità e base giuridica</LegalH>
      <LegalP>
        I dati sono trattati per: (a) eseguire il contratto di acquisto dei servizi di coaching; (b) rispondere alle
        richieste inviate tramite il modulo contatti; (c) adempiere obblighi fiscali e contabili; (d) inviare,
        previo consenso, comunicazioni relative ai servizi acquistati.
      </LegalP>
      <LegalH>4. Conservazione</LegalH>
      <LegalP>
        I dati contrattuali e fiscali sono conservati per 10 anni in ottemperanza agli obblighi di legge. I messaggi
        inviati tramite il modulo contatti sono conservati per il tempo necessario a gestire la richiesta.
      </LegalP>
      <LegalH>5. Diritti dell'interessato</LegalH>
      <LegalP>
        Puoi esercitare in qualsiasi momento i diritti di accesso, rettifica, cancellazione, limitazione, portabilità
        e opposizione scrivendo a mpcoaching.online@gmail.com. Hai inoltre diritto di reclamo al Garante per la protezione
        dei dati personali (www.garanteprivacy.it).
      </LegalP>
      <LegalH>6. Trasferimenti</LegalH>
      <LegalP>
        Il trattamento dei pagamenti avviene tramite Stripe Payments Europe Ltd. Per i dettagli sul trattamento dei
        dati da parte di Stripe: https://stripe.com/it/privacy.
      </LegalP>
    </LegalPage>
  );
}
